import React from "react";

const PhFillWarningCircleSvg = ({ size = 17 }: { size?: number }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 256 256"
		fill="currentColor"
		aria-hidden
	>
		<path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-8,56a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" />
	</svg>
);

export default PhFillWarningCircleSvg;
